import { useQuery } from "@tanstack/react-query";
import { useInitialQueriesEnabled } from "@hooks/useInitialQueriesEnabled";
import {
  getBannerMessages,
  getMessages,
  getPopupMessages,
} from "@services/messages/services";
import type {
  IBannerMessage,
  IMessage,
  IPopupMessage,
} from "@services/messages/types";

export const useMessagesQuery = () => {
  const enabled = useInitialQueriesEnabled();

  return useQuery<IMessage[]>({
    queryKey: ["messages"],
    queryFn: getMessages,
    enabled: enabled,
  });
};

export const useBannerMessagesQuery = () =>
  useQuery<IBannerMessage[]>({
    queryKey: ["bannerMessages"],
    queryFn: () => getBannerMessages(),
  });

export const usePopupMessagesQuery = (enabled?: boolean) =>
  useQuery<IPopupMessage[]>({
    queryKey: ["popupMessages"],
    queryFn: getPopupMessages,
    enabled,
  });
